<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form [formGroup]="gpsTypeForm" class="admin-forms">
  <div class="accordion-class">
    <h5 *ngIf="data.type === 'New'">Add GPS Type</h5>
    <h5 *ngIf="data.type === 'Edit'">Edit GPS Type</h5>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group">
      <div class="mb-3 pull-left w-100">
        <mat-form-field>
          <mat-label>Server Name:</mat-label>
          <input
            matInput
            formControlName="server_name"
            style="text-transform: capitalize"
            required
          />
          <mat-error
            *ngIf="(GpsTypeFormControl['server_name'].touched) && GpsTypeFormControl['server_name'].errors?.['required']"
          >
            Please Enter Server Name
          </mat-error>
          <mat-error
            *ngIf="(GpsTypeFormControl['server_name'].touched) && GpsTypeFormControl['server_name'].errors?.['pattern']"
          >
            Please Enter Valid Server Name
          </mat-error>
        </mat-form-field>
      </div>
      <div class="mb-3 pull-left w-100">
        <mat-form-field>
          <mat-label>Server Url:</mat-label>
          <input matInput formControlName="server_url" required />
          <mat-error
            *ngIf="(GpsTypeFormControl['server_url'].touched) && GpsTypeFormControl['server_url'].errors?.['required']"
            >Please Enter Server URL</mat-error
          >
        </mat-form-field>
      </div>
      <div class="mb-3 pull-left w-100">
        <mat-form-field>
          <mat-label>Server Token</mat-label>
          <input type="password" matInput formControlName="server_token" required />
          <mat-error
            *ngIf="(GpsTypeFormControl['server_token'].touched) && GpsTypeFormControl['server_token'].errors?.['required']"
            >Please Enter Server Token</mat-error
          >
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="btn-container">
    <button
    [class.spinner]="loading"
    [disabled]="loading"
    *ngIf="data.type === 'New'"
    type="button"
    class="button buttonBlue"
    (click)="AddGpsType()"
  >
    Submit
  </button>
  <button
    [class.spinner]="loading"
    [disabled]="loading"
    *ngIf="data.type === 'Edit'"
    type="button"
    class="button buttonBlue"
    (click)="EditGpsType()"
  >
    Submit
  </button>
  </div>
</form>
